<template>
    <div data-form-client>
        <div v-for="(field, index) in visibleFields" :key="index" class="">
            <FormClientField
                :recordable-type="recordableType"
                :recordable-id="recordableId"
                :unique-constraint-show-url="uniqueConstraintShowUrl"
                :merge-search-url="mergeSearchUrl"
                :merge-label="mergeLabel"
                :field="field"
                :data="data"
                :value="data[name(field)]"
            />
        </div>
    </div>
</template>

<script>
import FormClientField from './FormClientField'
import * as Form from '@App/Utils/Form'

export default {
    props: [
        'fields',
        'value',
        'recordableType',
        'recordableId',
        'uniqueConstraintShowUrl',
        'mergeSearchUrl',
        'mergeLabel',
    ],
    components: {
        FormClientField,
    },
    data() {
        return { data: this.value || {} }
    },
    mounted() {
        this.$el.$el = this
    },
    computed: {
        allFields() {
            return (this.fields || []).filter((e) => e)
        },

        visibleFields() {
            return this.fields.filter((field) => {
                return this.shouldShow(field)
            })
        },
    },
    methods: {
        isValid() {
            for (let field of this.visibleFields) {
                if (Form.required(field)) {
                    let $field = this.$el.querySelector('[data-for="' + this.name(field) + '"]')

                    const defaultRequired = () => this.data[this.name(field)]

                    if ($field) {
                        let $component = $field.querySelector('[data-component]')
                        if ($component) {
                            if ($component.validateRequired) {
                                if (!$component.validateRequired()) {
                                    $field.flashInvalid()
                                    return false
                                }
                            } else {
                                if (!defaultRequired()) {
                                    $field.flashInvalid()
                                    return false
                                }
                            }
                        } else {
                            if (!defaultRequired()) {
                                $field.flashInvalid()
                                return false
                            }
                        }
                    } else {
                        if (!defaultRequired()) return false
                    }
                }
            }

            return true
        },

        /**
         * Serializa os campos de acordo com os campos visíveis.
         *
         * @return {object}
         */
        serialize() {
            let filtered = {}
            this.allFields.forEach((field) => {
                let name = Form.name(field)
                if (this.shouldShow(field)) {
                    let value = this.data[name]

                    // Campos que contém outros campos.
                    if (typeof value === 'object' && value && value._spread) {
                        Object.keys(value)
                            .filter((key) => key != '_spread')
                            .forEach((key) => {
                                filtered[key] = value[key] || ''
                            })
                    } else {
                        filtered[name] = this.data[name] || ''
                    }
                } else {
                    filtered[name] = ''
                }
            })

            return filtered
        },

        reset(newData) {
            this.data = newData
        },

        shouldShow(field) {
            let conditionals

            if (field.referenced_conditionals == 'override') {
                conditionals = field.overriden_conditionals || []
            } else if (field.reference) {
                conditionals = field.reference.atributos_extras.conditionals
            } else if (field.atributos_extras) {
                conditionals = field.atributos_extras.conditionals
            }

            if (conditionals && Array.isArray(conditionals) && conditionals.length > 0) {
                let allPass = this.allConditionalsPass(conditionals)
                if (!allPass) return false
                let allParents = this.allParentsPass(conditionals)
                if (!allParents) return false
            }

            return true
        },

        allParentsPass(conditionals) {
            for (let condition of conditionals) {
                let attributeNames = Object.keys(condition)
                for (let name of attributeNames) {
                    let parentField = this.findFieldByName(name)
                    if (parentField) {
                        if (!this.shouldShow(parentField)) return false
                    }
                }
            }
            return true
        },

        allConditionalsPass(conditionals) {
            for (let condition of conditionals) {
                if (!Form.conditionalMatch(this.data, condition)) {
                    return false
                }
            }

            return true
        },

        name(field) {
            return Form.name(field)
        },

        type(field) {
            return Form.type(field)
        },

        buttonUrl(field) {
            if (field.atributos_extras && field.atributos_extras.button_url) return field.atributos_extras.button_url
        },

        findFieldByName(name) {
            return this.allFields.find((field) => {
                return this.name(field) == name
            })
        },
    },
}
</script>